import { render, staticRenderFns } from "./driverStat.vue?vue&type=template&id=54ce43f8&"
import script from "./driverStat.vue?vue&type=script&lang=js&"
export * from "./driverStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports